<div class="main-1">
  <div class="annotation-title">Annotations viewer</div>
</div>
<div class="main-1">

  <div class="forBigDesktop">
    <div class="nightingale-container" *ngIf="isBrowser">
      <div *ngIf="accession() && heatmapSequence && visReadyToRender === true" class="protvista-components">
        <pv-angular-wrapper
          containerId="afdb-protvista"
          [sequence]="heatmapSequence"
          [data]="afdbData()"
          [entryId]="accession().toLowerCase()"
          [entityId]="afdbEntityId"
          [chainId]="afdbChainId"
          [tooltips]="afdbTooltips"
          [externalEvents]="true"
          customTrackControls="scroll-1"
          maxHeight="none"
          (addCustomTrackEvent)="toggleAddTrackDialog($event)"
          (editCustomTracksEvent)="toggleEditTrackDialog($event)"
          (openSearchHighlightEvent)="toggleZoomDialog($event)"
          (colourIn3DEvent)="triggerIn3DColouring($event)"
        ></pv-angular-wrapper>
        <app-zoom-annotations
          *ngIf="isZoomDialogOpen"
          [sequenceLength]="heatmapSequence.length"
          (closeDialog)="closeZoomDialog()"
          (zoomAnnotations)="zoomAndHighlightTrack($event)"
        ></app-zoom-annotations>
        <app-add-annotations
          *ngIf="isAddDialogOpen"
          [sequenceLength]="heatmapSequence.length"
          (closeDialog)="closeAddTrackDialog()"
          (addAnnotations)="mapYourData($event)"
        ></app-add-annotations>
        <app-edit-annotations
          *ngIf="isEditDialogOpen"
          [sequenceLength]="heatmapSequence.length"
          [customRawData]="customRawData"
          [customTracks]="customTracks"
          (closeDialog)="closeEditTrackDialog()"
          (editAnnotations)="editAnnotationsTrack($event)"
        ></app-edit-annotations>
      </div>

      <section class="section-tracks" *ngIf="csvAMFileUrl && csvAmData">
        <span></span>
        <div class="filter-container">
          <div class="category-filter">
            <div class="title-reset-container">
              <div class="filter-title">Filter by category</div>
              <a class="resetLink" (click)="resetFilters()" *ngIf="isReset"
                >Reset filters</a
              >
            </div>
  
            <div class="vf-form__item vf-form__item--checkbox benignBox">
              <div class="catogeryBox">
                <input
                  #benign
                  type="checkbox"
                  id="benign"
                  value="benign"
                  class="vf-form__checkbox"
                  [checked]="isBenign"
                  (change)="
                    (!isBenign);
                    isBenignDisabled = !isBenignDisabled;
                    handleFilters('category', 'benign')
                  "
                  [(ngModel)]="isBenign"
                />
                <label for="benign" class="vf-form__label">Likely benign</label>
              </div>
              <div class="sliderBox">
                <mat-slider
                  #mySlider1
                  min="0"
                  max="0.34"
                  step="0.01"
                  [discrete]="true"
                  [disabled]="isBenignDisabled"
                  (change)="handleFilters('range', 'benign')"
                >
                  <input
                    matSliderStartThumb
                    [(ngModel)]="silder1Min"
                    #slider1_min
                  />
                  <input
                    matSliderEndThumb
                    [(ngModel)]="silder1Max"
                    #slider1_max
                  />
                </mat-slider>
                <div
                  class="benign-range-values"
                  [ngClass]="isBenignDisabled ? 'disabled-num' : ''"
                >
                  <span>0.0</span>
  
                  <span>0.34</span>
                </div>
              </div>
            </div>
  
            <div class="vf-form__item vf-form__item--checkbox uncertainBox">
              <div class="catogeryBox">
                <input
                  #uncertain
                  type="checkbox"
                  id="uncertain"
                  value="ambiguous"
                  class="vf-form__checkbox"
                  [checked]="isUncertain"
                  (change)="
                    (!isUncertain);
                    isUncertainDisabled = !isUncertainDisabled;
                    handleFilters('category', 'uncertain')
                  "
                  [(ngModel)]="isUncertain"
                />
                <label for="uncertain" class="vf-form__label">Uncertain</label>
              </div>
              <div class="sliderBox">
                <mat-slider
                  #mySlider2
                  min="0.34"
                  max="0.56"
                  step="0.01"
                  [disabled]="isUncertainDisabled"
                  [discrete]="true"
                  (change)="handleFilters('range', 'uncertain')"
                >
                  <input
                    matSliderStartThumb
                    [(ngModel)]="silder2Min"
                    #slider2_min
                  />
                  <input
                    matSliderEndThumb
                    [(ngModel)]="silder2Max"
                    #slider2_max
                  />
                </mat-slider>
                <div
                  class="uncertain-range-values"
                  [ngClass]="isUncertainDisabled ? 'disabled-num' : ''"
                >
                  <span>0.34</span>
  
                  <span>0.564</span>
                </div>
              </div>
            </div>
  
            <div class="vf-form__item vf-form__item--checkbox pathogenicBox">
              <div class="catogeryBox">
                <input
                  #pathogenic
                  type="checkbox"
                  id="pathogenic"
                  value="pathogenic"
                  class="vf-form__checkbox"
                  [checked]="isPathogenic"
                  (change)="
                    (!isPathogenic);
                    isPathogenicDisabled = !isPathogenicDisabled;
                    handleFilters('category', 'pathogenic')
                  "
                  [(ngModel)]="isPathogenic"
                />
                <label for="pathogenic" class="vf-form__label"
                  >Likely pathogenic</label
                >
              </div>
              <div class="sliderBox">
                <mat-slider
                  #mySlider3
                  min="0.56"
                  max="1"
                  step="0.01"
                  [disabled]="isPathogenicDisabled"
                  [discrete]="true"
                  (change)="handleFilters('range', 'pathogenic')"
                >
                  <input
                    matSliderStartThumb
                    [(ngModel)]="silder3Min"
                    #slider3_min
                  />
                  <input
                    matSliderEndThumb
                    [(ngModel)]="silder3Max"
                    #slider3_max
                  />
                </mat-slider>
                <div
                  class="pathogenic-range-values"
                  [ngClass]="isPathogenicDisabled ? 'disabled-num' : ''"
                >
                  <span>0.564</span>
  
                  <span>1</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</div>

